<template>
  <ul class="noty-container">
    <li v-for="noty in noties" :key="noty.id" :type="noty.type || $store.getters[noty.typeFunc]">
      <div>
        <div class="noty__body" @click="noty.onclick && noty.onclick(); remove(noty.id)">
          <span v-if="noty.text">{{noty.text}}</span>
          <span v-else-if="noty.func">{{$store.getters[noty.func](noty.params)}}</span>
        </div>
        <div class="noty__close" @click="remove(noty.id)">
          <span aria-hidden="true">x</span>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "noty-container",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ noties: "notiesToShow" })
  },
  methods: {
    ...mapMutations(["removeNoty"]),
    remove(id) {
      this.removeNoty(id);
    }
  }
};
</script>

<style scoped lang="scss">
.noty-container {
  position: fixed;
  height: auto;
  bottom: 0;
  list-style-type: none;
  z-index: 10000000;
  padding: 0;
  width: 100%;
}

li {
  padding: 0px;
  position: relative;
  width: 100%;
  color: white;
  border: solid white;
  border-width: 0 0 1px 0;

  &[type="error"] {
    background-color: $red-color;
  }
  &[type="info"] {
    background-color: $bluish-two-color;
  }

  .noty__body {
    padding: 0.9rem;
    font-size: 0.9rem;
    width: 90%;
    display: inline-block;
  }
  .noty__close {
    width: 10%;
    display: inline-block;
    vertical-align: top;
  }
}
</style>
